import { createContext, useContext } from 'react';
import { WhatsAppSenderFields } from 'modules/graphql/types';

export interface WhatsAppSenderContextContextState {
  senders: WhatsAppSenderFields[];
}

export const WhatsAppSenderContext = createContext<WhatsAppSenderContextContextState>({
  senders: [],
});

export const useWhatsAppSenderContext = () => useContext(WhatsAppSenderContext);
